import { AppErrorBoundary } from '@/components';

import MuiThemeProvider from './mui-theme-provider';
import { AppRouterProvider } from './router-provider';
import TanstackQueryProvider from './tanstack-query-provider';
import { ToastProvider } from './toast-provider';
import AuthProvider from './auth-provider';

export const rootProvider = [
  TanstackQueryProvider,
  AuthProvider,
  MuiThemeProvider,
  AppErrorBoundary,
  AppRouterProvider,
  ToastProvider
];
